var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResolved = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 300 300",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.82 145.8a63.2 63.2 0 0 1-16.16 9.37l2.42 7.26H183.8l-13.15 26.3h-41.3l-13.15-26.3H69.92l20.69-62.01a17.13 17.13 0 0 1 16.25-11.74h34.49c.76-6.44 2.49-12.6 5.04-18.3h-39.52c-15.27 0-28.78 9.74-33.62 24.22L48.8 167.95v56.23c0 19.55 15.9 35.45 35.45 35.45h131.5c19.55 0 35.45-15.9 35.45-35.45v-56.23zm-10.92 78.38c0 8.27-5.89 15.2-13.7 16.8-1.11.23-2.27.35-3.45.35H84.25c-1.18 0-2.34-.12-3.45-.35-7.81-1.6-13.7-8.53-13.7-16.8v-43.45h37.8l1.06 2.12 5.9 11.86c3.8 7.6 11.44 12.32 19.94 12.32h36.4c8.5 0 16.14-4.72 19.94-12.32l5.9-11.86 1.06-2.12h37.8z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.35 50.73c-25.06 0-45.44 20.38-45.44 45.44s20.38 45.44 45.44 45.44 45.44-20.39 45.44-45.44-20.39-45.44-45.44-45.44m27.69 35.32-32.63 32.63c-.88.89-1.91 1.16-2.61 1.23-.23.02-.48.02-.71 0-.71-.07-1.74-.34-2.62-1.24l-16.82-16.82c-1.66-1.66-1.66-4.38 0-6.05l6.33-6.33c.84-.83 1.94-1.25 3.03-1.25s2.19.42 3.02 1.25l7.41 7.41 23.21-23.22a4.3 4.3 0 0 1 3.03-1.25h.01c1.14 0 2.21.45 3.01 1.25l6.34 6.34a4.28 4.28 0 0 1 0 6.05",
    className: "cls-1"
  })));
};
export default SvgResolved;